module.exports = __webpack_public_path__ + "static/7-47b88a8df13e28d8f9be9be5bdcf7032.jpg";